import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
  Hidden,
} from "@material-ui/core";
import useTable from "../useTable";
import {
  ValidCaptcha,
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
  validaNumeroTelefono,
  validaEmail,
  validaDecimal,
  formatoDeci,
} from "../../util/varios";
import axios from "axios";
import TablaDeudaAgenteTasa from "./deudasAgentes";
import TablaHistoAgenteTasa from "./historicoAgentes";
import { ModalTasas } from "./modalTasas";
import moment from "moment";

export const GestionAsignacionTasa = (props) => {
  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code">
          {" "}
          ID
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Descripción",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-calendar-alt">
          {" "}
          FECHA
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Código Clase",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-clipboard-list">
          {" "}
          TIPO TASA
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Código Clase",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code-branch">
          {" "}
          CONCEPTO
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Código Clase",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-money-bill-wave">
          {" "}
          MONTO
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Código Clase",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-clipboard-check">
          {" "}
          PAGADA
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-cogs">
          {" "}
          OPCIONES
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
  ];

  const [mostrar, setMostrar] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [operacionTasa, setOperacionTasa] = useState(false);
  const [municipios, setMunicipios] = useState();
  const [impuestos, setImpuestos] = useState();
  const [records, setRecords] = useState([]);
  const [tipoTasa, setTipoTasa] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [totDeuda, setTotDeuda] = useState("0,00");
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [values, setValues] = useState({
    idagente: "",
    nombre: "",
    direccion: "",
    rif: "",
    nrolicencia: "",
    nroresolucion: "",
  });
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [idTasa, setIdTasa] = useState();
  const txtAlicuota = useRef();
  const txtMinimo = useRef();
  const txtId = useRef();
  const txtDescrip = useRef();
  const txtCodigo = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const chkBs = useRef();
  const chkUt = useRef();
  const cmbImuesto = useRef();
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idtipotasa.includes(target.value) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.codigotasa.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/tasas/actualizarclases`;
    let body;
    setActivate(true);

    body = {
      operacion: operacion,
      nid: values.idtipotasa !== "" ? parseInt(values.idtipotasa) : 0,
      cod: values.codigotasa.trim(),
      descr: values.descripcion,
      val: parseFloat(
        txtMinimo.current.value.trim().replace(/\./g, "").replace(",", ".")
      ),
      faccal: parseInt(values.factorcalculo),
      tipimp: values.tipoimpuesto.trim(),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(body);

          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const SeleccionarImpuestos = () => {
    setActivate(true);

    let campos = "trim(descripcion) as descripcion";
    let nomtab = "tipoimpuesto";
    let orden = "idtipoimpuesto";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setImpuestos(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const onChange = (event) => {
    if (
      event.target.name === "codigoclaseminas" ||
      event.target.name === "descripcion" ||
      event.target.name === "codigotasa"
    ) {
      event.target.value = event.target.value.toUpperCase();
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "tipoimpuesto") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "factorcalculo") {
      setValues({
        ...values,
        [event.target.name]: parseInt(event.target.value),
      });
    }
  };

  const seleccionarRegistro = (idtasa) => {
    let endpoint = `${op.conexion}/api/tasas/tipotasaxtasa?idtasa=${idtasa}`;
    console.log(endpoint);
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setTipoTasa(response.data);
          setActivate(false);
          setMostrar(true);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      if (event.which === 13) {
        if (event.target.id === "alicuotas") {
          txtAlicuota.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const selectTasas = (idagente, fecha, tipoimpu) => {
    let endpoint = `${op.conexion}/api/tasas/seleccionartasas?idagente=${idagente}&fecha=${fecha}&tipoimpu=${tipoimpu}`;
    console.log(endpoint);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data !== "") {
            console.log(response.data);
            var deu = [];
            var his = [];
            var totdeu = parseFloat(0.0);
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].status === 1) {
                his.push({
                  fechatasa: response.data[i].mondeu,
                  tipotasa: response.data[i].descri,
                  concepto: response.data[i].concept,
                  monto: response.data[i].mon,
                  recibo: response.data[i].idfact,
                  fechapago: response.data[i].fecpago,
                });
              } else {
                totdeu = totdeu + parseFloat(response.data[i].mon);
                deu.push({
                  fechatasa: response.data[i].mondeu,
                  tipotasa: response.data[i].descri,
                  concepto: response.data[i].concept,
                  monto: response.data[i].mon,
                });
              }
            }
            setTotDeuda(
              formatMoneda(totdeu.toString().replace(".", ","), ",", ".", 2)
            );
            setDeuda(deu);
            setHistorico(his);
            setRecords(response.data);
          }
        }

        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (values.codigotasa === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el Código de la tasa",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (values.tipoimpuesto === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el tipo de Impuesto",
        icono: "informacion",
      });
      sigue = false;
      cmbImuesto.current.focus();
    } else if (values.descripcion === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa el Nombre del Clasificador",
        icono: "informacion",
      });
      sigue = false;
      txtDescrip.current.focus();
    } else if (txtMinimo.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el valor de la tasa",
        icono: "informacion",
      });
      sigue = false;
      txtMinimo.current.focus();
    } else if (!chkBs.current.checked && !chkUt.current.checked) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el factor calculo",
        icono: "informacion",
      });
      sigue = false;
      chkBs.current.focus();
    } else if (sigue) {
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const blanquear = () => {
    setActivate(false);
    setValues({
      idagente: "",
      nombre: "",
      direccion: "",
      rif: "",
      nrolicencia: "",
      nroresolucion: "",
    });
    setOperacion(0);
  };

  const handleCloseSi = () => {
    Actualizar();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarModal = () => {
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const closeModal = () => {
    setMostrar(false);
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  const gestionTasa = (op, id) => (e) => {
    e.preventDefault();
    setOperacionTasa(op);
    setIdTasa(id);
    if (op === 1) {
      setMostrar(true);
    } else {
      seleccionarRegistro(id);
    }
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        SeleccionarImpuestos();
        setValues(props.agente);

        btnAcepta.current.focus();
        setOperacion(props.operacion);
        selectTasas(
          props.agente.idagente,
          moment(fechaSistema).format("YYYY-MM-DD"),
          props.idTipoImpuesto
        );
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Detalles de la Tasa</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
        <ModalTasas
          show={mostrar}
          onHideCancela={closeModal}
          tipoimpuesto={props.tipoimpuesto}
          operacion={operacionTasa}
          idagente={values.idagente !== null ? values.idagente : 0}
          tipoTasa={tipoTasa}
          idTipoImpuesto={props.idTipoImpuesto}
          idTasa={idTasa}
          onHideRenderizar={selectTasas}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div style={{ height: "auto", overflow: "auto" }}>
          <div className="row rounded mx-auto border py-2">
            <div class="input-group input-group-sm mb-2 col-md-2">
              <label
                class="input-group-text fw-bold border-0 bg-transparent"
                id="inputGroup-sizing-sm"
              >
                Código:
              </label>
              <input
                type="text"
                class="form-control border-0 bg-transparent fw-bold"
                disabled
                aria-label="Sizing example input"
                defaultValue={
                  values
                    ? values.idagente !== null
                      ? values.idagente.trim()
                      : ""
                    : ""
                }
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>

            <div class="input-group input-group-sm mb-2 col-md-2">
              <label
                class="input-group-text fw-bold border-0 bg-transparent"
                id="inputGroup-sizing-sm"
              >
                Rif:
              </label>
              <input
                type="text"
                class="form-control border-0 bg-transparent fw-bold"
                disabled
                aria-label="Sizing example input"
                defaultValue={
                  values ? (values.rif !== null ? values.rif.trim() : "") : ""
                }
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>

            <div className="col-md-4"></div>

            <div class="input-group input-group-sm mb-2 col-md-2">
              <label
                class="input-group-text fw-bold border-0 bg-transparent"
                id="inputGroup-sizing-sm"
              >
                N° Licencia:
              </label>
              <input
                type="text"
                class="form-control border-0 bg-transparent fw-bold"
                disabled
                aria-label="Sizing example input"
                defaultValue={
                  values
                    ? values.nrolicencia !== null
                      ? values.nrolicencia.trim()
                      : ""
                    : ""
                }
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>

            <div class="input-group input-group-sm mb-2 col-md-2">
              <label
                class="input-group-text fw-bold border-0 bg-transparent"
                id="inputGroup-sizing-sm"
              >
                N° Resolución:
              </label>
              <input
                type="text"
                class="form-control border-0 bg-transparent fw-bold"
                disabled
                aria-label="Sizing example input"
                defaultValue={
                  values
                    ? values.nroresolucion !== null
                      ? values.nroresolucion.trim()
                      : ""
                    : ""
                }
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>

            <div class="input-group input-group-sm mb-2 col-md-6">
              <label
                class="input-group-text fw-bold border-0 bg-transparent"
                id="inputGroup-sizing-sm"
              >
                Nombre del Agente:
              </label>
              <input
                type="text"
                class="form-control border-0 bg-transparent fw-bold"
                disabled
                defaultValue={
                  values
                    ? values.nombre !== null
                      ? values.nombre.trim()
                      : ""
                    : ""
                }
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>

            <div class="input-group input-group-sm mb-2 col-md-6">
              <label
                class="input-group-text fw-bold border-0 bg-transparent"
                id="inputGroup-sizing-sm"
              >
                Dirección:
              </label>
              <input
                type="text"
                class="form-control border-0 bg-transparent fw-bold"
                disabled
                aria-label="Sizing example input"
                defaultValue={
                  values
                    ? values.direccion !== null
                      ? values.direccion.trim()
                      : ""
                    : ""
                }
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
          </div>

          <ul className="nav mb-2 mt-2" id="ex-with-icons" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="nav-link text-dark rounded"
                style={{ backgroundColor: "#25d366" }}
                id="ex-with-icons-tab-1"
                data-mdb-toggle="tab"
                href="#ex-with-icons-tabs-1"
                role="tab"
                aria-controls="ex-with-icons-tabs-1"
                aria-selected="true"
              >
                <i className="fas fa-chart-pie fa-fw me-2" />
                Tasas del Agente
              </a>
            </li>

            <li className="nav-item" role="presentation">
              <a
                className="nav-link text-light rounded"
                style={{ backgroundColor: "#F93154" }}
                id="ex-with-icons-tab-3"
                data-mdb-toggle="tab"
                href="#ex-with-icons-tabs-3"
                role="tab"
                aria-controls="ex-with-icons-tabs-3"
                aria-selected="false"
              >
                <i className="fas fa-money-check fa-fw me-2" />
                Deudas
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link text-dark rounded"
                style={{ backgroundColor: "#FFA900" }}
                id="ex-with-icons-tab-4"
                data-mdb-toggle="tab"
                href="#ex-with-icons-tabs-4"
                role="tab"
                aria-controls="ex-with-icons-tabs-4"
                aria-selected="false"
              >
                <i className="fas fa-book-open fa-fw me-2" />
                Historico
              </a>
            </li>
          </ul>
          <div
            className="tab-content"
            id="ex-with-icons-content"
            style={{ fontFamily: "Times New Roman, Times, serif" }}
          >
            <div
              className="tab-pane fade show active"
              id="ex-with-icons-tabs-1"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-1"
            >
              <div className="row col-md-12 d-flex justify-content-end">
                <div className="col-3 d-flex justify-content-end">
                  <button
                    style={{ marginBottom: "5px" }}
                    onClick={gestionTasa(1, "")}
                    className="btn btn-sm btn-primary rounded-circle"
                  >
                    <i className="fas fa-plus"></i>{" "}
                  </button>
                </div>
              </div>
              <div className="col-md-12" style={{ margin: "auto" }}>
                <TblContainer>
                  <TblHead />

                  <TableBody>
                    {records &&
                      recordsAfterPagingAndSorting().map((item, index) => (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell style={{ textAlign: "center" }}>
                            {item.idtas}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {moment(item.fectas).format("DD/MM/YYYY")}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {item.descri}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {item.concept}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {item.mon}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {item.txtestatus}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            <button
                              className="btn btn-sm  btn-info rounded-circle ml-2"
                              onClick={gestionTasa(4, item.idtas)}
                            >
                              <i className="fas fa-eye"></i>{" "}
                            </button>
                            <button
                              className="btn btn-sm  btn-warning rounded-circle ml-2"
                              onClick={gestionTasa(2, item.idtas)}
                            >
                              <i className="fa fa-edit"></i>{" "}
                            </button>
                            <button
                              className="btn btn-sm  btn-danger rounded-circle ml-2"
                              onClick={gestionTasa(3, item.idtas)}
                            >
                              <i className="fa fa-trash"></i>{" "}
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
                <TblPagination />
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="ex-with-icons-tabs-3"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-3"
            >
              <TablaDeudaAgenteTasa tabdeuda={deuda} credito={"0,00"} />
            </div>
            <div
              className="tab-pane fade"
              id="ex-with-icons-tabs-4"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-4"
            >
              <TablaHistoAgenteTasa tabpago={historico} />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          style={{ visibility: "hidden" }}
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success "
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill "
        >
          <i className="fas fa-window-close"> Salir</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/tasas/modalAsignarTasa.js